import AdsClickIcon from "@mui/icons-material/AdsClick";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description";
import SegmentIcon from "@mui/icons-material/Segment";
import ShareIcon2 from "@mui/icons-material/Share";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Skeleton from "@mui/material/Skeleton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";

import { FareRulesModal } from "components/app-modals";
import ItineraryComponent from "components/itinerary";
import { roundPrice } from "utils/packageDealPrice";

import Iconify from "components/iconify";
import Badge from "../badge";
import Button from "../button";
import AppModalFlightDetails from "../modal";
import NoBaggageModal from "../noBaggageModal";

import { getUserFromLocalStorage } from "hooks/LocalStorage";
import useApi from "hooks/useApi";
import { useTranslation } from "i18n";
import { flightHasNoCheckedBaggage } from "utils/baggage";
import { checkISAdminOrEmployee } from "utils/Utils";

import { getLatestCurrencyExchange } from "api/currency";
import { fareRules, sharingLink } from "api/Flights";
import { postFlightTarget } from "api/FlightTarget";

import "./style.css";

const ResultCard = ({
  flight,
  destinationLocationCode,
  originLocationCode,
  dictionaries,
  handeValidatFlight,
  onApplyBaggageFilter,
  totalPrice,
  currency,
  cardID,
  returnDate,
  departurDate,
  handleOpenCommissionModal,
  flightType,
  officeId,
  flightSearchCriteria,
  getSelectedFLight,
  adjustedPrice,
  setAdjustedPrice,
  checked,
  setChecked,
  handlePrintComponent,
  hasSale,
  itineraries,
  getSellingForSurinamePrice,
  packageDeal = false,
  packagePrice = null,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [isOpenRareRulesModal, setOpenRareRulesModal] = useState(false);
  const [openSellingForModal, setOpenSellingForModal] = useState(false);
  const [openNoBaggageModal, setOpenNoBaggageModal] = useState(false);
  const [showPrice, setShowPrice] = useState(false);

  const [isTargetLoading, setTargetLoading] = useState(false);
  const [targetDescription, setTargetDescription] = useState("");
  const [isTargetOpen, setTargetOpen] = useState(false);
  const [success, setSuccess] = useState("");

  const [currencyRates, setCurrencyRates] = useState(null);
  const [currencyRatesLoading, setCurrencyRatesLoading] = useState(false);
  const [currencyRatesError, setCurrencyRatesError] = useState(false);

  const fareRulesApi = useApi(fareRules);

  const url = encodeURIComponent(
    `${window.location.href}&cardNum=${flight?.id}`,
  );
  const ref = useRef(null);

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "12px",
    boxShadow: 24,
    width: { xs: "92%", md: 420 },
    p: 4,
    maxHeight: "90vh",
    overflow: "auto",
    "&:focus": { outline: "none" },
  };

  const formatNumber = (n, opts = {}) => {
    const num = Number(n);
    if (!Number.isFinite(num)) return "";
    const { maximumFractionDigits = 2, minimumFractionDigits = 0 } = opts;

    return new Intl.NumberFormat(undefined, {
      maximumFractionDigits,
      minimumFractionDigits,
    }).format(num);
  };

  const formatSplitPrice = (n) => {
    const formatted = formatNumber(n, {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
    if (!formatted) return { whole: "", decimal: "", cents: "" };

    const match = formatted.match(/^(.+?)([.,])(\d+)$/);
    if (!match) return { whole: formatted, decimal: "", cents: "" };

    return {
      whole: match[1],
      decimal: match[2],
      cents: match[3],
    };
  };

  const parseAirport = (value) => {
    if (!value) return { iata: "", city: "" };
    const iata = value.substring(0, 3);
    const city = value.slice(4).split(",")[0]?.trim() || "";
    return { iata, city };
  };

  const handleEditTotalPrice = () => {
    getSelectedFLight(flight);
    setOpenSellingForModal(true);
    setAdjustedPrice(0);
  };

  const handelClickOpen = (boolean) => {
    setOpen(boolean);
  };

  const handleCloseSellingForModal = () => {
    setShowPrice(true);
    setOpenSellingForModal(false);
    handlePrintComponent();
  };

  const handleOpenFareRulesModal = () => {
    setOpenRareRulesModal(true);
  };

  useEffect(() => {
    if (!isOpenRareRulesModal) return;

    const body = {
      schema: flight,
      isPrivateFare: false,
      ...(officeId && { officeId }),
    };

    fareRulesApi.request({ body });
  }, [isOpenRareRulesModal]);

  const handleShareLink = async () => {
    const res = await sharingLink({ url });
    return res;
  };

  const handelSelectFlight = () => {
    if (flightHasNoCheckedBaggage(flight)) {
      setOpenNoBaggageModal(true);
      return;
    }

    handeValidatFlight(flight);
  };

  const handleContinueWithoutBaggage = () => {
    setOpenNoBaggageModal(false);
    handeValidatFlight(flight);
  };

  const handelGetFlightNumbers = () => {
    const numbers = [];
    for (let i = 0; i < flight?.itineraries?.length; i++) {
      for (let j = 0; j < flight?.itineraries?.[i]?.segments?.length; j++) {
        const segment = flight?.itineraries?.[i]?.segments?.[j];
        if (segment?.carrierCode && segment?.number) {
          numbers.push(segment.carrierCode + segment.number);
        }
      }
    }
    return numbers;
  };

  const handlePostTargetFlight = async ({ body }) => {
    const res = await postFlightTarget({ body });

    if (!res.ok) {
      setSuccess("error");
      setTargetLoading(false);
      setTimeout(() => {
        handleCloseTarget();
      }, 1000);
      return;
    }

    setSuccess("success");
    setTargetLoading(false);
    setTimeout(() => {
      handleCloseTarget();
    }, 1000);
  };

  const handleFlightTarget = async (e) => {
    e.preventDefault();

    if (!targetDescription) {
      setSuccess("error");
      return;
    }

    setTargetLoading(true);
    setSuccess("");

    const response = await handleShareLink();

    const body = {
      flightNumbers: handelGetFlightNumbers(),
      currency: flightSearchCriteria?.currencyCode,
      initialPrice: totalPrice(flight),
      searchType: "MASTER_PRICER",
      description: targetDescription,
      flightSearchCriteria,
      source: flight?.source,
    };

    if (!response.ok) {
      body.requestUrl = url;
      handlePostTargetFlight({ body });
      return;
    }

    body.requestUrl = response?.data?.shortLink;
    handlePostTargetFlight({ body });
  };

  const handleCloseTarget = () => {
    setTargetOpen(false);
    setSuccess(false);
    setTargetDescription("");
  };

  const handleCloseFareRulesModal = () => {
    setOpenRareRulesModal(false);
  };

  const shouldShowSRD = String(originLocationCode || "").includes("PBM");

  const isUsdCurrency = useMemo(() => {
    const c = String(currency || "")
      .trim()
      .toUpperCase();
    return c === "$" || c === "USD" || c === "US$";
  }, [currency]);

  const shouldFetchSrdRate = shouldShowSRD && isUsdCurrency;

  const bankPriceUsd = useMemo(() => {
    const p = showPrice && adjustedPrice ? adjustedPrice : totalPrice(flight);
    const num = Number(p);
    const flightPrice = Number.isFinite(num) ? num : 0;
    const pkg = packageDeal && packagePrice != null ? roundPrice(packagePrice) : 0;
    const pkgNum = Number.isFinite(pkg) ? pkg : 0;
    return roundPrice(flightPrice + pkgNum);
  }, [showPrice, adjustedPrice, flight, totalPrice, packageDeal, packagePrice]);

  const exchangeRate = useMemo(() => {
    if (!currencyRates) return null;
    if (!isUsdCurrency) return null;

    const r = Number(currencyRates?.usdRate);
    return Number.isFinite(r) ? r : null;
  }, [currencyRates, isUsdCurrency]);

  const bankPriceSrd = useMemo(() => {
    if (!shouldFetchSrdRate) return null;
    if (!exchangeRate) return null;

    const v = bankPriceUsd * exchangeRate;
    if (!Number.isFinite(v)) return null;

    return v;
  }, [shouldFetchSrdRate, exchangeRate, bankPriceUsd]);

  useEffect(() => {
    let isMounted = true;

    const run = async () => {
      if (!shouldFetchSrdRate) return;

      setCurrencyRatesLoading(true);
      setCurrencyRatesError(false);

      const res = await getLatestCurrencyExchange();

      if (!isMounted) return;

      if (!res?.ok) {
        setCurrencyRatesError(true);
        setCurrencyRates(null);
        setCurrencyRatesLoading(false);
        return;
      }

      setCurrencyRates(res?.data || null);
      setCurrencyRatesLoading(false);
    };

    run();

    return () => {
      isMounted = false;
    };
  }, [shouldFetchSrdRate]);

  const pricePanel = useMemo(() => {
    const flightOnly = showPrice && adjustedPrice ? adjustedPrice : totalPrice(flight);
    const flightNum = Number(flightOnly);
    const flightPrice = Number.isFinite(flightNum) ? flightNum : 0;
    const pkg = packageDeal && packagePrice != null ? Number(packagePrice) : 0;
    const pkgNum = Number.isFinite(pkg) ? pkg : 0;
    const splitPrice = formatSplitPrice(bankPriceUsd);

    return (
      <Box
        mt={0.75}
        width="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{ px: 1 }}
      >
        {/* Package deal badge */}
        {packageDeal && (
          <Box
            sx={{
              fontSize: "11px",
              fontWeight: 600,
              color: "primary.main",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              mb: 0.5,
            }}
          >
            Package deal
          </Box>
        )}
        {/* Primary price: large whole digits, smaller cents */}
        <Typography
          className="text-center result-card-price__amount"
          display="flex"
          alignItems="baseline"
          justifyContent="center"
          component="div"
        >
          <span className="result-card-price__currency">{currency}</span>
          <span className="result-card-price__whole">{splitPrice.whole}</span>
          {splitPrice.cents ? (
            <span className="result-card-price__fraction">
              <span className="result-card-price__decimal">
                {splitPrice.decimal}
              </span>
              <span className="result-card-price__cents">{splitPrice.cents}</span>
            </span>
          ) : null}
        </Typography>
        {packageDeal && pkgNum > 0 && (
          <Typography
            variant="caption"
            sx={{ opacity: 0.8, fontSize: "11px", mt: 0.5 }}
          >
            Flight {currency} {formatNumber(flightPrice, { maximumFractionDigits: 2 })} + Package {currency} {formatNumber(pkgNum, { maximumFractionDigits: 2 })}
          </Typography>
        )}

        {/* Secondary SRD price */}
        {shouldFetchSrdRate && (
          <Box mt={1} width="100%" display="flex" justifyContent="center">
            {currencyRatesLoading ? (
              <Skeleton variant="rounded" width={200} height={28} />
            ) : currencyRatesError ? (
              <Typography
                fontSize="12px"
                sx={{ opacity: 0.75 }}
                className="text-center"
              >
                SRD conversion unavailable
              </Typography>
            ) : bankPriceSrd ? (
              <Box
                sx={{
                  width: "100%",
                  maxWidth: 320,
                  borderRadius: "12px",
                  border: "1px solid rgba(0,0,0,0.08)",
                  background: "rgba(0,0,0,0.02)",
                  px: 1.25,
                  py: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight={800}
                  className="text-center"
                  sx={{ letterSpacing: "0.2px" }}
                >
                  SRD {formatNumber(bankPriceSrd, { maximumFractionDigits: 0 })}
                </Typography>
              </Box>
            ) : null}
          </Box>
        )}
      </Box>
    );
  }, [
    currency,
    bankPriceUsd,
    bankPriceSrd,
    shouldFetchSrdRate,
    currencyRatesLoading,
    currencyRatesError,
    packageDeal,
    packagePrice,
    showPrice,
    adjustedPrice,
    flight,
    totalPrice,
  ]);

  return (
    <>
      <div
        className={`card-wrapper ${
          cardID === flight?.id && !hasSale ? "active" : "inactive"
        }${hasSale ? " is-price-drop" : ""}`}
        ref={ref}
      >
        {hasSale && (
          <>
            <div className="price-drop-flare" aria-hidden="true">
              <span className="price-drop-flare__ring" />
            </div>
            <div className="price-drop-banner">
              <span className="price-drop-banner__icon">
                <ArrowDownwardRoundedIcon />
              </span>
              <span className="price-drop-banner__label">
                {t("resultCard.priceDrop")}
              </span>
            </div>
          </>
        )}

        <div className="circle-card one"></div>
        <div className="circle-card two"></div>
        <div className="circle-card three"></div>
        <div className="circle-card four"></div>

        <div className="result-card-main">
          <Box display="flex" mt={1} mr={1} justifyContent="flex-end">
            {getUserFromLocalStorage()?.type === "ADMIN" && (
              <Tooltip title={t("resultCard.targetFlight")}>
                <IconButton onClick={() => setTargetOpen(true)}>
                  <AdsClickIcon />
                </IconButton>
              </Tooltip>
            )}

            {checkISAdminOrEmployee() && (
              <Tooltip title={t("resultCard.analyze")}>
                <IconButton onClick={() => handleOpenCommissionModal(flight)}>
                  <AnalyticsIcon />
                </IconButton>
              </Tooltip>
            )}
          </Box>

          <div className="result-card">
            {flight?.itineraries?.map((itinerary, idxItinerary) =>
              itinerary?.segments?.map((item, idxSegment) => (
                <ItineraryComponent
                  key={`${idxItinerary}_${idxSegment}`}
                  index={idxSegment}
                  itinerary={itinerary}
                  segment={item}
                  dictionaries={dictionaries}
                  flight={flight}
                  destinationLocationCode={destinationLocationCode}
                  originLocationCode={originLocationCode}
                />
              )),
            )}

            <div className="results-card-badges d-flex justify-content-between">
              {flightType !== "One-way" && (
                <Badge
                  title={t("resultCard.days", {
                    count:
                      moment(returnDate).diff(moment(departurDate), "days") + 1,
                  })}
                  className="teal"
                />
              )}

              <div className="badges">
                <Button
                  className="desktop-show"
                  onClick={() => handelClickOpen(true)}
                >
                  <DescriptionIcon className="normal-size" />{" "}
                  {t("resultCard.showDetails")}
                </Button>

                {getUserFromLocalStorage()?.type &&
                  getUserFromLocalStorage()?.type !== "MEMBER" && (
                    <Button onClick={handleEditTotalPrice}>
                      <ShareIcon2 className="normal-size" />
                      {t("resultCard.shareQuote")}
                    </Button>
                  )}

                <Button onClick={handleOpenFareRulesModal}>
                  <SegmentIcon className="normal-size" />
                  {t("resultCard.viewRules")}
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="result-card-price">
          <div className="position-relative d-flex flex-column align-items-center">
            {pricePanel}

            {flight?.numberOfBookableSeats && (
              <Box mt={1}>
                <Badge
                  className="teal"
                  title={t("resultCard.seatsLeft", {
                    count: flight?.numberOfBookableSeats,
                  })}
                />
              </Box>
            )}
          </div>

          <div className="btn-footer-wrapper">
            <Button
              onClick={() => handelClickOpen(true)}
              className="show-mobile"
            >
              {t("resultCard.showDetails")}
            </Button>

            <Button className="primary-color" onClick={handelSelectFlight}>
              {t("common.select")}
            </Button>
          </div>
        </div>
      </div>

      <AppModalFlightDetails
        open={open}
        handelClickOpen={handelClickOpen}
        flight={flight}
        dictionaries={dictionaries}
        destinationLocationCode={destinationLocationCode}
        originLocationCode={originLocationCode}
        onClick={handelSelectFlight}
        currency={currency}
        priceTotal={
          packageDeal && packagePrice != null
            ? roundPrice(Number(totalPrice(flight)) + Number(packagePrice))
            : totalPrice(flight)
        }
      />

      <FareRulesModal
        open={isOpenRareRulesModal}
        onClose={handleCloseFareRulesModal}
        isLoading={fareRulesApi.loading}
        isError={fareRulesApi.error}
        data={fareRulesApi}
        flight={flight}
      />

      <Modal open={isTargetOpen} onClose={handleCloseTarget}>
        <Box sx={modalStyle}>
          <Typography variant="h6" mb={1} fontWeight={900}>
            {t("resultCard.targetFlight")}
          </Typography>

          <Box component="form" onSubmit={handleFlightTarget}>
            {success && (
              <Alert severity={success} sx={{ mb: 2 }}>
                {success === "success"
                  ? t("resultCard.targetedSuccess")
                  : t("resultCard.error")}
              </Alert>
            )}

            <div className="input-group-container">
              <label>{t("resultCard.description")}</label>
              <div className="input-wapper textarea">
                <textarea
                  value={targetDescription}
                  onChange={(e) => setTargetDescription(e.target.value)}
                  rows="5"
                  required
                  className="p-2"
                />
              </div>
            </div>

            <Box
              display="flex"
              alignItems="center"
              gap={1.5}
              mt={3}
              justifyContent="flex-end"
            >
              <Button
                loading={isTargetLoading}
                type="submit"
                className="primary-color"
              >
                {t("resultCard.targetFlight")}
              </Button>
              <Button onClick={handleCloseTarget}>{t("common.cancel")}</Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <NoBaggageModal
        open={openNoBaggageModal}
        onClose={() => setOpenNoBaggageModal(false)}
        onContinue={handleContinueWithoutBaggage}
        onApplyBaggageFilter={onApplyBaggageFilter}
      />

      <Modal
        open={openSellingForModal}
        onClose={() => setOpenSellingForModal(false)}
        aria-labelledby="share-quote-title"
        aria-describedby="share-quote-description"
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(15, 23, 42, 0.45)",
            backdropFilter: "blur(6px)",
          },
        }}
      >
        <Box className="share-quote-modal" tabIndex={-1}>
          <div className="share-quote-modal__glow" />
          <IconButton
            className="share-quote-modal__close"
            onClick={() => setOpenSellingForModal(false)}
            aria-label={t("common.close")}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          <div className="share-quote-modal__content">
            <div className="share-quote-modal__hero">
              <span className="share-quote-modal__icon" aria-hidden="true">
                <Iconify icon="solar:share-bold" width={26} />
              </span>
              <h2 id="share-quote-title" className="share-quote-modal__title">
                {t("resultCard.shareQuote")}
              </h2>
              <p
                id="share-quote-description"
                className="share-quote-modal__subtitle"
              >
                {t("resultCard.shareQuoteSubtitle")}
              </p>
            </div>

            <p className="share-quote-modal__section">
              {t("resultCard.shareQuoteRoute")}
            </p>
            <div className="share-quote-modal__routes">
              {itineraries?.map((flt, index) => {
                const from = parseAirport(flt?.from);
                const to = parseAirport(flt?.to);
                return (
                  <div className="share-quote-modal__route" key={index}>
                    <div className="share-quote-modal__airport">
                      <span className="share-quote-modal__iata">
                        {from.iata}
                      </span>
                      {from.city && (
                        <span className="share-quote-modal__city">
                          {from.city}
                        </span>
                      )}
                    </div>
                    <span
                      className="share-quote-modal__arrow"
                      aria-hidden="true"
                    >
                      <Iconify icon="mdi:airplane" width={18} />
                    </span>
                    <div className="share-quote-modal__airport share-quote-modal__airport--end">
                      <span className="share-quote-modal__iata">{to.iata}</span>
                      {to.city && (
                        <span className="share-quote-modal__city">
                          {to.city}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="share-quote-modal__prices">
              <div className="share-quote-modal__price share-quote-modal__price--primary">
                <span className="share-quote-modal__price-label">
                  {t("resultCard.totalBankPrice", { currency })}
                </span>
                <span className="share-quote-modal__price-value">
                  {currency} {adjustedPrice || totalPrice(flight)}
                </span>
              </div>
              {getSellingForSurinamePrice() && checked && (
                <div className="share-quote-modal__price">
                  <span className="share-quote-modal__price-label">
                    {t("resultCard.totalCashPrice", { currency })}
                  </span>
                  <span className="share-quote-modal__price-value">
                    {currency} {getSellingForSurinamePrice()}
                  </span>
                </div>
              )}
            </div>

            <div className="share-quote-modal__actions">
              <Button onClick={() => setOpenSellingForModal(false)}>
                {t("common.cancel")}
              </Button>
              <Button
                className="primary-color"
                onClick={handleCloseSellingForModal}
              >
                <ShareIcon2 />
                {t("resultCard.shareQuoteDownload")}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ResultCard;
